// extracted by mini-css-extract-plugin
export var card = "ItemListing-module--card--62240";
export var container = "ItemListing-module--container--4b8bd";
export var divider = "ItemListing-module--divider--3a0b6";
export var fadeIn = "ItemListing-module--fadeIn--86fff";
export var loading = "ItemListing-module--loading--6353c";